import { render, staticRenderFns } from "./TypographyConfig.vue?vue&type=template&id=1e59d681&"
import script from "./TypographyConfig.vue?vue&type=script&lang=js&"
export * from "./TypographyConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports